import cn from "classnames";
import styles from "./CustomerSelector.module.scss";
import { ICustomerSelectorProps, useCustomerSelectorControl } from "./useCustomerSelectorControl";
import { Tag } from "antd";
import { makeColor } from "@utils/hexToRgb";
import { drawTagWithoutDates, UserTagsService } from "@utils/userTags";
import CommonSelector from "../CommonSelector/CommonSelector";
import { UserI } from "@services/getUsers";
import { formatUser, OWNER_BACK_ID } from "./CustomerSelector.service";
import { useEffect } from "react";
import { useIntl } from "react-intl";

export default function CustomerSelector(props: Omit<ICustomerSelectorProps, "formatter">) {

  const { formatMessage } = useIntl();
  const control = useCustomerSelectorControl({ ...props, formatter: formatMessage });

  return (
    <CommonSelector
      showSearch
      error={control.hasNotFoundedUsers ? control.t("CustomerSelector.hasNotFoundedUser") : undefined}
      id={props.id}
      disabled={props.disabled}
      hasPrevText={!props.withoutPrevText}
      hasCleanUp={props.hasCleanUp}
      name={props.name}
      filterOption={(input, option) => {
        return option?.value === input || (typeof option?.label === "string" && option.label.toLowerCase().includes(input.toLowerCase()));
      }}

      options={control.options}
      onCleanUp={props.onCleanUp}
      clearedValue={control.CLEARED_VALUE}
      currentValue={control.currentValue}
      popupMatchSelectWidth={false}

      renderOption={(id) => {
        if (control.CLEARED_VALUE.id === id) {
          return control.CLEARED_VALUE.text;
        }
        if (id === OWNER_BACK_ID) {
          return control.t("CustomerSelector.back_to_owner");
        }
        let user = control.findUser(id);
        if (!user) {

        }
        if (!user) return null;
        return <CustomerSelector.Option {...{ ...user, formatter: formatMessage }} />;
      }}
      reset={props.reset}
      onChange={id => {
        control.onGetCustomer(id as string)
      }}
      outlined={props.outlined}
    />
  );
}

CustomerSelector.Option = (props: UserI & { formatter: ReturnType<typeof useIntl>['formatMessage'] }) => {

  const tag = new UserTagsService(props.tags || "").getFirstTag() || "";

  return (
    <div
      className={cn(styles.option_wrapper, {
        [styles.isAdmin]: props.is_admin,
      })}
    >
      <span>{formatUser(props, props.formatter)}</span>
      {props.tags && (
        <Tag
          className={styles.tag}
          color={props.color}
          style={{ color: makeColor(props.color) }}
        >
          {drawTagWithoutDates(tag)}
        </Tag>
      )}
    </div>
  );
};
